import { z } from 'zod';

import { optionalString } from '@utils/validation';

export const dataConstants = {
	DLN: 'dln',
};

export const testContent = {
	page_header: "Do you have a driver's license?",
	page_description:
		'<p>Your state uses driver&rsquo;s license number, in addition to social security number, to check the frequency of your testosterone refills, because testosterone is classified as a controlled substance.</p>',
	yes_answer_label: 'Yes',
	no_answer_label: 'No',
};

export const schema = z.object({
	[dataConstants.DLN]: optionalString,
});
